<template>
  <tr @click="$emit(`toggle`, row)" class="cursor-pointer">
    <td v-for="(el, i) in model" :key="i" class="text-left px-2" :class="{ 'error--text': row.color == 'red' }">
      <template v-if="el.name === 'group' && row.group">
        <span class="mr-1">{{ row.open ? "−" : "+" }}</span>
      </template>
      <div v-else-if="el.type" class="d-flex align-center gap-1">
        <component :is="'a-view-' + el.type" :model="el" :values="row" :value="el.value || row[el.name]" />
        <a-view-buttons v-if="el.configActions" :model="el" :values="row" />
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  components: {
    Row: () => import("./tableRow"),
  },
  props: {
    row: Object,
    model: { type: Array, default: () => [] },
  },
  data() {
    return {
      opened: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
